import { CapoPlugin } from "/home/ubuntu/deployments/2025-05-23-1339/rtg-monorepo/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];